
























import {Component, Prop, Watch} from 'vue-property-decorator';
import UrlMixin from '@/components/query/url-mixin';
import {mixins} from 'vue-class-component';

@Component
export default class ErrorBlock extends mixins(UrlMixin) {

  @Prop(String) errorText!: string;
  top: number = 0;
  loading: boolean = false;

  get isChartOpen() {
    return this.$store.state.table.chartOpen;
  }

  mounted(){
    setTimeout(()=>{
      let wrapper: HTMLElement | null = document.querySelector('.report-wrapper');
      this.top = wrapper ? wrapper.getBoundingClientRect().top : 0;
      this.$forceUpdate();
    },100)
  }

  clickSend() {
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 1000);
  }

}

